module.exports = __webpack_public_path__ + "static/img_9-96acdd838fc21ec46ef0e42110f56fd9.png";